import { ElementWithIcon } from "@/Common/Components/ElementWithIcon";
import { IconButton } from "@/Common/Components/IconControls/IconControls";
import { usePreferredPharmacyHelper } from "@/ContactDirectory/Hooks/usePreferredPharmacyHelper";
import { DirectoryPharmacy } from "@/ContactDirectory/Models/DirectoryPharmacy";
import { PharmacyProxy } from "@/ContactDirectory/Models/PharmacyProxy";
import { InvalidPharmacyWarningMessage } from "../Common/InvalidPharmacyWarningMessage";

import styles from "./PreferredPharmacyComponent.module.scss";

interface IPreferredPharmacyComponentProps {
    preferredPharmacy: PharmacyProxy;
    patientContactId: string;
    onEdit?: (model: DirectoryPharmacy) => void;
    disableEdit?: boolean;
}

export function PreferredPharmacyComponent(props: IPreferredPharmacyComponentProps): JSX.Element {
    const preferredPharmacyHelper = usePreferredPharmacyHelper(props.patientContactId);

    const pharmacyInfo = props.preferredPharmacy.getPharmacyInfo(true, preferredPharmacyHelper);
    const banner = pharmacyInfo?.Banner;
    const pharmacists = pharmacyInfo?.Name;
    const phone = pharmacyInfo?.Phone;
    const fax = pharmacyInfo?.Fax;

    return (
        <div className={styles.subContainer}>
            {props.preferredPharmacy && (
                <>
                    {!props.disableEdit && props.preferredPharmacy.getDirectoryPharmacy() && (
                        <IconButton
                            type="pen"
                            color="darkblue"
                            buttonClassName="float-right margin-sm-left"
                            onClick={() => props.onEdit?.(props.preferredPharmacy.getDirectoryPharmacy())}
                        />
                    )}
                    <ul>
                        <li className={`blue ${styles.subtitle} ellipsis-auto`}>
                            <ElementWithIcon includeIcon={cacheStore.validateMylePharmacy(!!pharmacyInfo.IsMylePharmacy)}>
                                <>{[banner, pharmacists].filter(p => !IsNullOrWhiteSpace(p)).join(" - ")}</>
                            </ElementWithIcon>
                        </li>
                        <li className="ellipsis-auto" title={pharmacyInfo.Address}>{pharmacyInfo.Address}</li>
                        <li>
                            {`T: ${phone || "--"}`}
                            <span className="separator">|</span>
                            {`F: ${fax || "--"}`}
                            {props.preferredPharmacy.getDirectoryPharmacy()?.isInvalid &&
                                <InvalidPharmacyWarningMessage />
                            }
                        </li>
                    </ul>

                </>
            )}
        </div>
    );
}
